import { Component, OnInit } from '@angular/core';
import { MasterPageService } from 'src/app/core/services/master-page.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit {

  listLink;
  constructor(private masterPageService:MasterPageService) { }

  ngOnInit(): void {
    this.masterPageService.getSideMenuItems().subscribe(items=>{
      this.listLink=items;
    })
  }

}
